import { createFileRoute } from "@tanstack/react-router";
import UeberUnsPage from "@/pages/UeberUnsPage";
import { buildRouteHead } from "@/lib/route-head";

export const Route = createFileRoute("/ueber-uns")({
  head: () =>
    buildRouteHead({
      title: "Über uns | Enno & Jens – Agentur aus dem Harz",
      description:
        "Lernen Sie Enno & Jens kennen – Ihre Webexperten aus Wernigerode im Harz. Persönlich, kompetent und regional in Sachsen-Anhalt verwurzelt.",
      path: "/ueber-uns",
      ogType: "profile",
    }),
  component: UeberUnsPage,
});
